const styles = (theme) => ({
  dialogPaper: {
    borderRadius: "16px",
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: 2.5,
  },
  iconRow: {
    display: "flex",
  },
  iconAjusteHint: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: theme.palette.colors.orange.medium,
    mt: -1.5,
  },
  field: {},
  section: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  sectionLabel: {
    fontWeight: 600,
    fontSize: "0.85rem",
  },
  sectionHint: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    mt: -0.5,
  },
  colorSection: {
    display: "flex",
    flexDirection: "column",
    gap: 0.8,
  },
  colorRow: {
    display: "flex",
    alignItems: "center",
    gap: 1.2,
  },
  colorSwatch: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid transparent",
    transition: "transform .1s ease, border-color .15s ease",
    "&:hover": {
      transform: "scale(1.08)",
    },
  },
  colorSwatchActive: {
    borderColor: theme.palette.text.primary,
  },
  colorCheckIcon: {
    fontSize: "16px",
    color: theme.palette.white.main,
  },
  colorSelectedLabel: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
  },
  monoField: {
    "& textarea": {
      fontFamily: "monospace",
      fontSize: "0.85rem",
    },
  },
  actions: {
    padding: theme.spacing(2, 3, 3),
  },
});

export default styles;
